import { React, useState, useEffect } from "react";
import Labels from "../../services/apiLabels";
import { POST } from "../../constant/apiMethods";
import { CREATE_CONTACT_US } from "../../constant";
import { scrollTop } from "../../utils/window";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";
import {
  HiOutlineLocationMarker,
  HiOutlinePhone,
  HiOutlineMail,
  HiOutlineArrowRight,
  HiOutlineChatAlt2,
  HiOutlineUser,
} from "react-icons/hi";

function ContactUs({ createContactUs }) {
  const { feedback } = useContext(FeedbackContext);
  const contact_us = {
    ...(feedback?.contact_us || {}),
    address_description: "DD DHA Phase 4, Lahore",
  };

  useEffect(() => {
    scrollTop();
  }, []);

  const [email, setemail] = useState("");
  const [fistname, setfistname] = useState("");
  const [lastname, setlastname] = useState("");
  const [coment, setcoment] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = () => {
    if (submitting) return;
    if (!email) return;

    setSubmitting(true);
    createContactUs(
      {
        email: email,
        fistname: fistname,
        lastname: lastname,
        coment: coment,
      },
      (response) => {
        setSubmitting(false);
        if (response?.message?.type === "success") {
          setemail("");
          setfistname("");
          setlastname("");
          setcoment("");
        }
      }
    );
  };

  const quickLinks = [
    {
      id: "sell",
      image: contact_us.sell_image,
      title: contact_us.sell_text,
      description: contact_us.sell_description,
      action: contact_us.sell_bottomtab,
      type: "phone",
    },
    {
      id: "questions",
      image: contact_us.questions_image,
      title: contact_us.questions_text,
      description: contact_us.questions_description,
      action: contact_us.questions_bottomtab,
      type: "link",
      to: "/faqs",
    },
    {
      id: "chat",
      image: contact_us.chat_iamge,
      title: contact_us.chat_text,
      description: contact_us.chat_description,
      action: contact_us.chat_bottomtab,
      type: "static",
    },
  ];

  return (
    <div className="pi-contact">
      <header className="pi-inner-hero pi-inner-hero--with-bar">
        <div className="pi-inner-hero__media" aria-hidden="true">
          <img
            className="pi-inner-hero__media-img"
            src={`${process.env.PUBLIC_URL || ""}/images/hero-international.jpg`}
            alt=""
          />
          <span className="pi-inner-hero__media-shade" />
        </div>
        <div className="pi-inner-hero__fx" aria-hidden="true">
          <span className="pi-inner-hero__glow pi-inner-hero__glow--a" />
          <span className="pi-inner-hero__glow pi-inner-hero__glow--b" />
          <span className="pi-inner-hero__grid" />
        </div>
        <div className="pi-inner-hero__content">
          <div className="pi-inner-hero__copy">
            <p className="pi-label pi-inner-hero__label">We are here to help</p>
            <h1 className="pi-inner-hero__title">{contact_us.contact_text}</h1>
            <p className="pi-inner-hero__lead">{contact_us.contactus_description}</p>
            <div className="pi-contact__hero-bar">
              <div className="pi-contact__hero-stat">
                <span className="pi-contact__hero-stat-icon" aria-hidden>
                  <HiOutlinePhone size={20} />
                </span>
                <div>
                  <span className="pi-contact__hero-stat-label">{contact_us.phoneno_text}</span>
                  <strong>{contact_us.phone_no}</strong>
                </div>
              </div>
              <div className="pi-contact__hero-stat">
                <span className="pi-contact__hero-stat-icon" aria-hidden>
                  <HiOutlineLocationMarker size={20} />
                </span>
                <div>
                  <span className="pi-contact__hero-stat-label">{contact_us.address_text}</span>
                  <strong>{contact_us.address_description}</strong>
                </div>
              </div>
              <div className="pi-contact__hero-stat">
                <span className="pi-contact__hero-stat-icon" aria-hidden>
                  <HiOutlineChatAlt2 size={20} />
                </span>
                <div>
                  <span className="pi-contact__hero-stat-label">{contact_us.chat_text}</span>
                  <strong>{contact_us.chat_bottomtab}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span className="pi-inner-hero__fade" aria-hidden="true" />
      </header>

      <div className="pi-contact__body">
        <div className="pi-contact__inner">
          <section className="pi-contact__channels" aria-label="Quick contact options">
            <div className="pi-section-head">
              <p className="pi-label">Support</p>
              <h2>Choose how you want to connect</h2>
              <p>Speak with our team, browse answers, or start a conversation online.</p>
            </div>
            <div className="pi-contact__channel-grid">
              {quickLinks.map((item) => (
                <article key={item.id} className="pi-contact__channel">
                  <div className="pi-contact__channel-top">
                    <div className="pi-contact__channel-icon">
                      <img src={item.image} alt="" />
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                  {item.type === "link" ? (
                    <Link to={item.to} className="pi-contact__channel-btn" name="CTAButton">
                      <span>{item.action}</span>
                      <HiOutlineArrowRight size={18} aria-hidden />
                    </Link>
                  ) : (
                    <span className="pi-contact__channel-btn pi-contact__channel-btn--static">
                      <span>{item.action}</span>
                    </span>
                  )}
                </article>
              ))}
            </div>
          </section>

          <div className="pi-contact__layout">
            <section className="pi-contact__main" aria-labelledby="contact-form-heading">
              <div className="pi-contact__panel">
                <div className="pi-contact__panel-head">
                  <span className="pi-contact__panel-icon" aria-hidden>
                    <HiOutlineMail size={22} />
                  </span>
                  <div>
                    <p className="pi-label">Message us</p>
                    <h2 id="contact-form-heading">{contact_us.contactus_form}</h2>
                    <p>Fill in your details and we will respond as soon as possible.</p>
                  </div>
                </div>

                <div className="pi-contact__form-grid">
                  <label className="pi-contact__field">
                    <span className="pi-contact__field-icon" aria-hidden>
                      <HiOutlineUser size={18} />
                    </span>
                    <input
                      value={fistname}
                      onChange={(e) => setfistname(e.target.value)}
                      className="pi-contact__input"
                      placeholder={contact_us.firstname_placeholder}
                    />
                  </label>
                  <label className="pi-contact__field">
                    <span className="pi-contact__field-icon" aria-hidden>
                      <HiOutlineUser size={18} />
                    </span>
                    <input
                      value={lastname}
                      onChange={(e) => setlastname(e.target.value)}
                      className="pi-contact__input"
                      placeholder={contact_us.lastname_placeholder}
                    />
                  </label>
                  <label className="pi-contact__field pi-contact__field--full">
                    <span className="pi-contact__field-icon" aria-hidden>
                      <HiOutlineMail size={18} />
                    </span>
                    <input
                      type="email"
                      onChange={(e) => setemail(e.target.value)}
                      value={email}
                      className="pi-contact__input"
                      placeholder={contact_us.email_placeholder}
                    />
                  </label>
                  <label className="pi-contact__field pi-contact__field--full pi-contact__field--area">
                    <span className="pi-contact__area-label">{contact_us.leave_placeholder}</span>
                    <textarea
                      value={coment}
                      onChange={(e) => setcoment(e.target.value)}
                      className="pi-contact__textarea"
                      rows={5}
                    />
                  </label>
                </div>

                <button
                  type="button"
                  className="pi-contact__submit"
                  name="CTAButton"
                  onClick={handleSubmit}
                  disabled={submitting}
                >
                  {submitting ? "Sending…" : contact_us.contactus_submit}
                </button>
              </div>
            </section>

            <aside className="pi-contact__aside">
              <div className="pi-contact__panel pi-contact__panel--office">
                <p className="pi-label">Our office</p>
                <h2>{contact_us.sellanywheel_heading}</h2>
                <p className="pi-contact__office-lead">{contact_us.sellanywheel_description}</p>

                <div className="pi-contact__detail-list">
                  <div className="pi-contact__detail">
                    <span className="pi-contact__detail-icon" aria-hidden>
                      <HiOutlineLocationMarker size={20} />
                    </span>
                    <div>
                      <h3>{contact_us.address_text}</h3>
                      <p>{contact_us.address_description}</p>
                    </div>
                  </div>
                  <div className="pi-contact__detail">
                    <span className="pi-contact__detail-icon" aria-hidden>
                      <HiOutlinePhone size={20} />
                    </span>
                    <div>
                      <h3>{contact_us.phoneno_text}</h3>
                      <p>{contact_us.phone_no}</p>
                    </div>
                  </div>
                </div>
              </div>
            </aside>
          </div>

          <section className="pi-contact__map-section" aria-labelledby="contact-map-heading">
            <div className="pi-section-head">
              <p className="pi-label">Visit us</p>
              <h2 id="contact-map-heading">Find our location</h2>
              <p>{contact_us.address_description}</p>
            </div>
            <div className="pi-contact__map-wrap">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m2!2m1!1sDHA+Phase+4,+Lahore,+Pakistan"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="DD DHA Phase 4, Lahore"
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  createContactUs: (data, callBack) =>
    dispatch({
      type: CREATE_CONTACT_US,
      payload: {
        type: CREATE_CONTACT_US,
        label: Labels.createContactUs,
        method: POST,
        data,
        hideOverlayLoader: true,
        callBack,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);
